export default __webpack_public_path__ + "/dist/images/2067483.png";